import React, { useEffect, useState } from 'react';
import {
    getJobsInformation,
    getDropdown,
    updateJobs,
    postJobActions,
    updatepublishJobs,
    getCandidateCount,
    RePublishJob,
} from '../service/RecruiterApi';
import moment from 'moment';
// import { RecruiterComponent } from './recruiter';
import { useNavigate } from 'react-router-dom';
import HiringProcess from './HiringProcess';
import Popup from './ConformationPopup/Popup';
import { OnlyNumberAndSpecialChar } from '../utils/RegHandling';
import EvaluationPopUp from '../components/EvaluationPopUp';
import ReactQuill from 'react-quill';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import 'react-quill/dist/quill.snow.css';

// import Loader from '../../StaticComponent/Loader';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import { encryptStorage } from '../constant';
import { RecruitmentComponent } from './recruitment';

export function JobInformation() {
    const Search = window.location.search;
    let job_Id = new URLSearchParams(Search).get('id');
    let job = new URLSearchParams(Search).get('job');
    const recruitRole = encryptStorage.getItem('recruitRole');

    let role = '';
    let path = window.location.pathname;
    const navigate = useNavigate();

    // const [previewData, setPreviewData] = useState({
    //     sourceID: '',
    //     college: '',
    // });
    /**
     * PS_02 - PS_03 -- Declaring the state variable
     */
    const [formData, setFormData] = useState({});
    const [departmentDD, setDepartmentDD] = useState([]);
    const [empTypeDD, setEmpTypeDD] = useState([]);
    const [currencyDD, setCurrencyDD] = useState([]);
    const [payFrequencyDD, setPayFrequencyDD] = useState([]);
    const [sourceDD, setSourceDD] = useState([]);
    const [collegeDD, setCollegeDD] = useState([]);
    const [Mode, setMode] = useState(false);
    const [experience, setExperience] = useState('');
    const [hidePublishButton, setHidePublishButton] = useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    let [remoteDisable, setRemoteDisable] = useState(false);
    const [publish, setpublish] = useState();
    const [flag, setFlag] = useState(true);
    const [count, setCount] = useState();
    const [jobtitleValidation, setJobtitleValidation] = useState('');
    const [departmentValidation, setDepartmentValidation] = useState('');
    const [employmentValidation, setEmploymentValidation] = useState('');
    const [resourceValidation, setResourceValidation] = useState('');
    const [currencyValidation, setCurrencyValidation] = useState('');
    const [minSalaryValidation, setMinSalaryValidation] = useState('');
    const [maxSalaryValidation, setMaxSalaryValidation] = useState('');
    const [payoutValidation, setPayoutValidation] = useState('');
    const [locationValidation, setLocationValidation] = useState('');
    const [experienceValidation, setExperienceValidation] = useState('');
    const [sourceValidation, setSourceValidation] = useState('');
    const [collegeValidation, setCollegeValidation] = useState('');
    const [descriptionValidation, setDescriptionValidation] = useState('');
    const [skillValidation, setSkillValidation] = useState('');
    const [insertToast, setinsertToast] = useState(false);
    const [ToastColor, setToastColor] = useState('');
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');
    const [convertedText, setConvertedText] = useState('');
    const [sanitizedDescription, setSanitizedDescription] = useState('');

    useEffect(() => {
        if (encryptStorage.getItem('groupid') == 1 || encryptStorage.getItem('recruitRole') == 'Panel Member') {
            loadData();
            getAllDropdowns();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, [Mode]);



    /**
     * PS_04 - PS_05 -- On the pageload prefill the data, where the getJobsInformation function is declared
     */

    let loadData = async () => {
        try {
            setIsLoading(false);
            let resp = await getJobsInformation({ jobID: job_Id });
            setIsLoading(true);
            var value = resp.data.data[0];

            let editObject = {
                jobTitle: value.job_title,
                employmentType: value.employment_type,
                department: value.department,
                currency: value.currency_type,
                departmentID: value.department_id,
                employmentID: value.employment_id,
                criticality: value.criticality,
                no_of_resource: '',
                criticalityID: value.criticality_id,
                currencyID: value.currency_id,
                minSalary: value.min_salary,
                maxSalary: value.max_salary,
                location: value.location,
                remoteJob: value.remote_job,
                experience: value.experience,
                sourceID: value.source_id,
                source: value.job_source_name,
                college: value.college_name,
                collegeId: value.college_id,
                description: value.description,
                draft: value.draft,
                isPublished: value.is_published,
                isClosed: value.is_closed,
                isDeleted: value.is_delete,
                isHold: value.is_hold,
                allowApply: '',
                createdAt: value.created_at,
                jobID: job_Id,
                skills: value.name,
                role: role,
                published_at: value.published_at,
            };
            setConvertedText(value.description);
            if (value.is_published == true) {
                setFlag(false);
            }

            const cleanDescription = DOMPurify.sanitize(value.description);
            setSanitizedDescription(cleanDescription);
            let data = await getCandidateCount({ id: job_Id, exp: value.experience });

            setCount(data.data.data[0].count);
            setExperience(value.experience);

            setFormData(editObject);
        } catch (e) {
            throw e;
        }
    };



    let breadCrumbsData = [
        { title: 'Dashboard', path: '/overview', isActive: true },

        { title: 'Jobs', path: '/Recruitment', isActive: true },

        { title: formData.jobTitle, path: '/Recruitment', isActive: false },
    ];

    let getAllDropdowns = async () => {
        try {
            let resp = await getDropdown();
            setDepartmentDD(resp.data.data[0]);
            setEmpTypeDD(resp.data.data[1]);
            setCurrencyDD(resp.data.data[2]);
            setPayFrequencyDD(resp.data.data[3]);
            setSourceDD(resp.data.data[4]);
            setCollegeDD(resp.data.data[5]);
        } catch (e) { }
    };



    // let onValueChange = (e) => {

    //     if (e.target.id == 'minSalary' && e.target.value != '') {
    //         let regexItem = new RegExp('^[0-9]*$');
    //         let checkValid = regexItem.test(e.target.value);
    //         if (isNaN(e.target.value)) {
    //             setMinSalaryValidation('Enter a Valid Min Salary');
    //         } else {
    //             setMinSalaryValidation('');
    //         }
    //     }
    //     if (e.target.id == 'maxSalary' && e.target.value != '') {
    //         let regexItem = new RegExp('^[0-9]*$');
    //         let check = regexItem.test(e.target.value);
    //         if (isNaN(e.target.value)) {
    //             setMaxSalaryValidation('Enter a Valid Max Salary');
    //         } else {
    //             setMaxSalaryValidation('');
    //         }
    //     }

    //     if (e.target.id == 'remoteJob') {
    //         setFormData({ ...formData, [e.target.id]: e.target.checked });
    //         setRemoteDisable(e.target.checked);
    //         setFormData((formData) => ({
    //             ...formData,
    //             ['location']: '',
    //         }));
    //         if (e.target.checked) {
    //             setLocationValidation('');
    //         } else {
    //             setLocationValidation('Location is required');
    //         }
    //     } else if (e.target.name == 'number') {
    //         if (/^[0-9\b]+$/.test(e.target.value) || e.target.value == '') {
    //             setFormData({ ...formData, [e.target.id]: e.target.value });
    //         }
    //     }
    //     // else if (e.target.id == 'sourceID' && e.target.value != '') {
    //     //     setFormData({ ...formData, [e.target.id]: e.target.value });
    //     //     setSourceValidation('');
    //     // } else if (e.target.id == 'college' && e.target.value != '') {
    //     //     setFormData({ ...formData, [e.target.id]: e.target.value });
    //     //     setCollegeValidation('');
    //     // }

    //     else if (e.target.name == 'dropdown') {
    //         setFormData({ ...formData, [e.target.id]: e.target.value });
    //     } else {
    //         setFormData({ ...formData, [e.target.id]: e.target.value });
    //     }
    


    // };

    let onValueChange = (e) => {
        const { id, value, checked, type } = e.target;
       
        

        let updatedData = { ...formData };

        if (id === 'minSalary' || id === 'maxSalary') {
            if (value !== '' && isNaN(value)) {
                if (id === 'minSalary') {
                    setMinSalaryValidation('Enter a Valid Min Salary');
                } else {
                    setMaxSalaryValidation('Enter a Valid Max Salary');
                }
            } else {
                updatedData[id] = value;
                if (id === 'minSalary') {
                    setMinSalaryValidation('');
                } else {
                    setMaxSalaryValidation('');
                }
            }
        } else if (id === 'remoteJob') {
            updatedData[id] = checked;
            setRemoteDisable(checked);
            updatedData['location'] = '';
            if (checked) {
                setLocationValidation('');
            } else {
                setLocationValidation('Location is required');
            }
        } else if (type === 'number') {
            if (/^[0-9\b]+$/.test(value) || value === '') {
                updatedData[id] = value;
            }
        }
        else if (id === 'collegeId') {
            updatedData.collegeId = value;
            // If you need to update the college name as well
            const selectedCollege = collegeDD.find(college => college.id === parseInt(value));
            updatedData.college = selectedCollege ? selectedCollege.college_name : '';
        }  else if (type === 'dropdown') {
            updatedData[id] = value;
        } else {
            updatedData[id] = value;
        }

        setFormData(updatedData);
    };
    const submit = (e) => {
        if (e.target.checked) {
            setpublish(true);
        }
    };
    const cancelJob = async () => {
        try {
            navigate('/recruitment');
        } catch (e) {
            throw e;
        }
    };
    const save = async () => {
        try {
            if (publish == true) {
                let modifiedTime = new Date();

                let published_at = moment(new Date(modifiedTime)).format('MMM DD, YYYY');

                let response = await updatepublishJobs({ id: job_Id, published_at: published_at });

                setFlag(false);
                loadData();
                getAllDropdowns();
                setinsertToast(true);
                setToastColor('green');

                setToastPara('Job is Published');
                setToastValue('Successfully Published');
            }
        } catch (e) { }
    };
    let bindDepartment = () => {
        try {
            return departmentDD.map((obj) => {
                return <option value={obj.id}>{obj.department}</option>;
            });
        } catch (e) { }
    };

    let bindEmpType = () => {
        try {
            return empTypeDD.map((obj) => {
                return <option value={obj.id}>{obj.employment_type}</option>;
            });
        } catch (e) { }
    };

    let bindCurrency = () => {
        try {
            return currencyDD.map((obj) => {
                return <option value={obj.id}>{obj.currency_type}</option>;
            });
        } catch (e) { }
    };
    /**
     * PS_20 - PS_21 -- Bind the Data using bind functions
     */
    let bindSource = () => {
        try {
            return sourceDD.map((obj) => {
                return <option value={obj.id}>{obj.job_source_name}</option>;
            });
        } catch (e) { }
    };

    let bindCollege = () => {
        try {
            return collegeDD.map((obj) => {
                return <option value={obj.id}>{obj.college_name}</option>;
            });
        } catch (e) { }
    };





    const Republish = async () => {
        try {
            let modifiedTime = new Date();
            let published_at = moment(new Date(modifiedTime)).format('MMM DD, YYYY');

            let data = { id: job_Id, published_at: published_at };
            const res = await RePublishJob(data);

            navigate('/Recruitment');
        } catch (e) { }
    };

    // let bindPayFrequency = () => {
    //      return payFrequencyDD.map((obj) => {
    //           return (<option value={obj.id} >{obj.frequency}</option>);
    //      })
    // }
    /**
     * PS_24 - PS_25 -- onchange function is handled the dropdown and validate the selected value using the validation function
     */
    let formValidation = () => {
        let result = true;
        if (formData.jobTitle == '') {
            setJobtitleValidation('Job Title is required');
            result = false;
        } else {
            setJobtitleValidation('');
        }
        if (formData.jobTitle !== '') {
            let checkregexjtitle = OnlyNumberAndSpecialChar(formData.jobTitle);
            if (checkregexjtitle) {
                setJobtitleValidation('Job title is not Valid');
                result = false;
            } else {
                setJobtitleValidation('');
            }
        }

        // if (formData.departmentID == 0) {
        //     setDepartmentValidation('Department is required');
        //     result = false;
        // } else {
        //     setDepartmentValidation('');
        // }

        if (formData.employmentID == 0) {
            setEmploymentValidation('Employment Type is required');
            result = false;
        } else {
            setEmploymentValidation('');
        }
        if (formData.currencyID == 0) {
            setCurrencyValidation('Currency is required');
            result = false;
        } else {
            setCurrencyValidation('');
        }
        if (formData.minSalary == '') {
            setMinSalaryValidation('Min Salary is required');
            result = false;
        } else {
            setMinSalaryValidation('');
        }
        if (parseInt(formData.minSalary) > parseInt(formData.maxSalary)) {
            setMinSalaryValidation('Min Salary must be less than or equal to max salary');
            result = false;
        }

        if (formData.maxSalary == '') {
            setMaxSalaryValidation('Max Salary is required');
            result = false;
        } else {
            setMaxSalaryValidation('');
        }
        let regexItem = new RegExp('^[0-9]*$');
        let checkValid = regexItem.test(formData.minSalary);
        if (isNaN(formData.minSalary)) {
            setMinSalaryValidation('Enter a Valid Min Salary');
            result = false;
        }
        let check = regexItem.test(formData.maxSalary);
        if (isNaN(formData.maxSalary)) {
            setMaxSalaryValidation('Enter a Valid Max Salary');
            result = false;
        }

        if (formData.location == '' && formData.remoteJob == false) {
            setLocationValidation('Location is required');
            result = false;
        } else {
            setLocationValidation('');
        }
        if (formData.experience == '') {
            setExperienceValidation('Experience is required');
            result = false;
        } else {
            setExperienceValidation('');
        }
        if (formData.sourceID == 0) {
            setSourceValidation('Source is required');
            result = false;
        } else {
            setSourceValidation('');
        }
        if (formData.college == '') {
            setCollegeValidation('College is required');
            result = false;
        } else {
            setCollegeValidation('');
        }
        // if (formData.skills == '') {
        //     setSkillValidation('Skills is required');
        //     result = false;
        // } else {
        //     setSkillValidation('');
        // }

        if (formData.skills !== '') {
            let checkregexskill = OnlyNumberAndSpecialChar(formData.skills);
            if (checkregexskill) {
                setSkillValidation('Skills is not Valid');
                result = false;
            } else {
                setSkillValidation('');
            }
        }

        if (convertedText == '<p><br></p>' || convertedText == undefined || convertedText == '') {
            setDescriptionValidation('Description is required');
            result = false;
        } else {
            let checkregex = OnlyNumberAndSpecialChar(convertedText);
            if (checkregex) {
                result = false;
                setDescriptionValidation('Description is not valid');
            } else {
                setDescriptionValidation('');
            }
        }

        return result;
    };
    /**
     * PS_28 - PS_31 -- checking the formValidation , if true it declares a variable and set the value
     * updateJobs function gets triggered 
     */
    let UpdateJobInformation = async () => {
        if (formValidation() == true) {
            setIsLoading(false);

            let value = formData;
            value['description'] = convertedText;
            let data = await updateJobs(value);

            setIsLoading(true);
            setMode(false);
        }
    };


    let publishJob = () => {
        window.location.href = `/Recruitment/Jobs?id=${job_Id}&job=publish`;
    };

    let PublishedMenuClick = async (value) => {
        let resp = await postJobActions({ action: value, id: formData.jobID });
        if (resp.data.statusCode == 200) {
            window.location.href = '/Recruitment';
        }
    };
    {
    }

    return (
        <div className="body-bg">
            <div className="container-fluid mt-5">
                <div className="row">
                    <BreadCrumbs data={breadCrumbsData} />
                    {/*Tab - Starts here */}
                    <div className="col-md-12 d-flex justify-content-between bg-white">
                        {insertToast ? (
                            <EvaluationPopUp color={ToastColor} Page={'Success Insert'} Heading={ToastValue} Paragraph={ToastPara} />
                        ) : null}
                        <ul className="nav nav-pills ps-1 semibold-text bold-text" id="pills-tab" role="tablist">
                            <li className="nav-item me-4">
                                {job === null ? (
                                    <button
                                        className="nav-link rounded-0 active bold-text tab-style"
                                        id="jobinformation-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#jobinformation"
                                        type="button"
                                        role="tab"
                                        aria-controls="jobinformation"
                                        aria-selected="true"
                                        onClick={() => {
                                            setHidePublishButton(false);
                                        }}
                                    >
                                        Job Information
                                    </button>
                                ) : (
                                    <button
                                        className="nav-link rounded-0  bold-text tab-style"
                                        id="jobinformation-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#jobinformation"
                                        type="button"
                                        role="tab"
                                        aria-controls="jobinformation"
                                        aria-selected="true"
                                        onClick={() => {
                                            setHidePublishButton(false);
                                        }}
                                    >
                                        Job Information
                                    </button>
                                )}
                            </li>
                            <li className="nav-item me-4" hidden={recruitRole == 'Panel Member' && role !== 'Hr Manager' ? true : false}>
                                {job === null ? (
                                    <button
                                        className="nav-link rounded-0 bold-text tab-style"
                                        id="jobboards-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#jobboards"
                                        type="button"
                                        role="tab"
                                        aria-controls="jobboards"
                                        aria-selected="false"
                                        onClick={() => {
                                            setHidePublishButton(false);
                                        }}
                                    >
                                        Job Boards
                                    </button>
                                ) : (
                                    <button
                                        className="nav-link active rounded-0 bold-text tab-style"
                                        id="jobboards-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#jobboards"
                                        type="button"
                                        role="tab"
                                        aria-controls="jobboards"
                                        aria-selected="false"
                                        onClick={() => {
                                            setHidePublishButton(false);
                                        }}
                                    >
                                        Job Boards
                                    </button>
                                )}
                            </li>
                            <li className="nav-item me-4" hidden={recruitRole == 'Panel Member' && role !== 'Hr Manager' ? true : false}>
                                <button
                                    className="nav-link rounded-0 bold-text tab-style"
                                    id="hiringprocess-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#hiringprocess"
                                    type="button"
                                    role="tab"
                                    aria-controls="hiringprocess"
                                    aria-selected="false"
                                    onClick={() => {
                                        setHidePublishButton(true);
                                    }}
                                >
                                    Hiring Process
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className="nav-link rounded-0 bold-text tab-style"
                                    id="candidates-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#candidates"
                                    type="button"
                                    role="tab"
                                    aria-controls="candidates"
                                    aria-selected="false"
                                    onClick={() => {
                                        setHidePublishButton(true);
                                    }}
                                >
                                    Candidates
                                </button>
                            </li>
                        </ul>
                        <div
                            className="dropdown align-self-center"
                            hidden={(recruitRole == 'Panel Member' && role !== 'Hr Manager') || hidePublishButton == true ? true : false}
                        >
                            {formData.isClosed == true ? (
                                <button
                                    className="btn btn-secondary hive-btn-primary small-button dropdown-toggle font-10 semibold-text border-0"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Closed
                                </button>
                            ) : formData.isHold == true ? (
                                <button
                                    className="btn btn-secondary hive-btn-primary small-button dropdown-toggle font-10 semibold-text border-0"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    On Hold
                                </button>
                            ) : formData.draft == true ? (
                                <button
                                    className="btn btn-secondary hive-btn-primary small-button dropdown-toggle font-10 semibold-text border-0"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Drafted
                                </button>
                            ) : formData.isPublished == false ? (
                                <button
                                    className="btn btn-secondary hive-btn-primary small-button dropdown-toggle font-10 semibold-text border-0"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Drafted
                                </button>
                            ) : formData.isPublished == true ? (
                                <button
                                    className="btn btn-secondary hive-btn-primary small-button dropdown-toggle font-10 semibold-text border-0"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Published
                                </button>
                            ) : null}

                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                {formData.isClosed == true ? (
                                    <li>
                                        <a className="dropdown-item semibold-text font-12" onClick={() => Republish('Publish')}>
                                            Re - Publish
                                            <span>
                                                <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                    Visible on your career portal and job boards
                                                </p>
                                            </span>
                                        </a>
                                    </li>
                                ) : formData.isHold == true ? (
                                    <>
                                        <li>
                                            <a className="dropdown-item semibold-text font-12" onClick={() => Republish('Publish')}>
                                                Re - Publish
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        Visible on your career portal and job boards
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item semibold-text font-12"
                                                href="#"
                                                onClick={() => PublishedMenuClick('Close')}
                                            >
                                                Close
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        This Job Posting has been completed
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                    </>
                                ) : formData.draft == true ? (
                                    <>
                                        <li>
                                            <a className="dropdown-item semibold-text font-12" onClick={() => publishJob('Publish')}>
                                                Publish
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        Visible on your career portal and job boards
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item semibold-text font-12"
                                                href="#"
                                                onClick={() => PublishedMenuClick('Hold')}
                                            >
                                                On Hold
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        Freeze job, stop adding new candidates
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item semibold-text font-12"
                                                href="#"
                                                onClick={() => PublishedMenuClick('Close')}
                                            >
                                                Close
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        This Job Posting has been completed
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                    </>
                                ) : formData.isPublished == false ? (
                                    <>
                                        <li>
                                            <a className="dropdown-item semibold-text font-12" onClick={() => publishJob('Publish')}>
                                                Publish
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        Visible on your career portal and job boards
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item semibold-text font-12"
                                                href="#"
                                                onClick={() => PublishedMenuClick('Hold')}
                                            >
                                                On Hold
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        Freeze job, stop adding new candidates
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item semibold-text font-12"
                                                href="#"
                                                onClick={() => PublishedMenuClick('Close')}
                                            >
                                                Close
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        This Job Posting has been completed
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                    </>
                                ) : formData.isPublished == true ? (
                                    <>
                                        <li>
                                            <a
                                                className="dropdown-item semibold-text font-12"
                                                href="#"
                                                onClick={() => PublishedMenuClick('Hold')}
                                            >
                                                On Hold
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        Freeze job, stop adding new candidates
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item semibold-text font-12"
                                                href="#"
                                                onClick={() => PublishedMenuClick('Close')}
                                            >
                                                Close
                                                <span>
                                                    <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                        This Job Posting has been completed
                                                    </p>
                                                </span>
                                            </a>
                                        </li>
                                    </>
                                ) : null}
                                {/* {formData.draft == false || formData.isClosed == true ? null : (
                                    <li>
                                        <a className="dropdown-item semibold-text font-12" onClick={() => publishJob('Publish')}>
                                            Publish
                                            <span>
                                                <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                    Visible on your career portal and job boards
                                                </p>
                                            </span>
                                        </a>
                                    </li>
                                )} */}
                                {/* {formData.draft == false && formData.isPublished == false ? (
                                    <li>
                                        <a className="dropdown-item semibold-text font-12" onClick={() => publishJob('Publish')}>
                                            Publish
                                            <span>
                                                <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                    Visible on your career portal and job boards
                                                </p>
                                            </span>
                                        </a>
                                    </li>
                                ) : null} */}
                                {/* {formData.isPublished == true || formData.isHold == true || formData.isClosed == true ? (
                                    <li>
                                        <a className="dropdown-item semibold-text font-12" onClick={() => Republish('Publish')}>
                                            Re - Publish
                                            <span>
                                                <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                    Visible on your career portal and job boards
                                                </p>
                                            </span>
                                        </a>
                                    </li>
                                ) : null} */}
                                {/* {formData.isHold !== true && formData.isClosed == false ? (
                                    <li>
                                        <a
                                            className="dropdown-item semibold-text font-12"
                                            href="#"
                                            onClick={() => PublishedMenuClick('Hold')}
                                        >
                                            On Hold
                                            <span>
                                                <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                    Freeze job, stop adding new candidates
                                                </p>
                                            </span>
                                        </a>
                                    </li>
                                ) : null} */}
                                {/* {formData.isClosed == false ? (
                                    <li>
                                        <a
                                            className="dropdown-item semibold-text font-12"
                                            href="#"
                                            onClick={() => PublishedMenuClick('Close')}
                                        >
                                            Close
                                            <span>
                                                <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                    This Job Posting has been completed
                                                </p>
                                            </span>
                                        </a>
                                    </li>
                                ) : null} */}
                                <li>
                                    <a
                                        className="dropdown-item semibold-text font-12"
                                        href="#"
                                        //onClick={() => PublishedMenuClick('Delete')}
                                        data-bs-toggle="modal"
                                        data-bs-target="#logout"
                                    >
                                        Delete
                                        <span>
                                            <p className="regular-text font-11 dropdown-sublabel-color mb-1">
                                                Move this Job Posting to trash
                                            </p>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>
                                <li>
                                    <a className="dropdown-item semibold-text font-12" href={`/Recruitment/AddJobs?id=${job_Id}`}>
                                        Make a Copy
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="tab-content" id="pills-tabContent">
                            {/* Job Information Tab Starts here */}

                            <div
                                className={job == null ? 'tab-pane fade show active ' : 'tab-pane fade '}
                                id="jobinformation"
                                role="tabpanel"
                                aria-labelledby="jobinformation-tab"
                            >
                                <Popup
                                    deleteData={() => {
                                        PublishedMenuClick('Delete');
                                    }}
                                />
                                {/*Content - Starts here */}
                                {Mode == true ? (
                                    <div className="row mt-3">
                                        <div className="col-md-9">
                                            <div className="card border-0">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-5 mb-3">
                                                            <label htmlFor="jobtitle" className="form-label hive-form-label">
                                                                Job Title
                                                            </label>
                                                            <input
                                                                id="jobTitle"
                                                                type="text"
                                                                value={formData.jobTitle}
                                                                onChange={onValueChange}
                                                                placeholder="Enter here"
                                                                className="form-control hive-form-control"
                                                                maxLength={50}
                                                            />
                                                            <span style={{ color: 'red' }}>{jobtitleValidation}</span>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="jobdesc" className="form-label hive-form-label">
                                                                Job Description
                                                            </label>
                                                            {/* <textarea
                                                                id="description"
                                                                value={formData.description}
                                                                onChange={onValueChange}
                                                                placeholder="Enter here"
                                                                className="form-control hive-form-control custom-textarea-style"
                                                                maxLength={1500}
                                                            /> */}
                                                            <ReactQuill
                                                                theme="snow"
                                                                id="description"
                                                                //className="  job-posting-commentbox"
                                                                value={convertedText}
                                                                onChange={setConvertedText}
                                                                className="custom-textarea-style"
                                                                style={{ minHeight: '100px' }}
                                                            />
                                                            <span style={{ color: 'red' }}>{descriptionValidation}</span>
                                                        </div>
                                                        <div className="col-md-12 mt-5">
                                                            <label htmlFor="skills" className="form-label hive-form-label">
                                                                Skills
                                                            </label>
                                                            <input
                                                                id="skills"
                                                                value={formData.skills}
                                                                onChange={onValueChange}
                                                                placeholder="Enter here"
                                                                className="form-control hive-form-control"
                                                                maxLength={1000}
                                                            />
                                                            <span style={{ color: 'red' }}>{skillValidation}</span>
                                                        </div>
                                                        <div className="col-md-12 d-flex justify-content-end mt-5">
                                                            <button
                                                                type="button"
                                                                className="btn hive-btn-secondary me-4"
                                                                onClick={() => {
                                                                    setMode(false);
                                                                }}
                                                            >
                                                                Cancel
                                                            </button>
                                                            {/*PS_26 - PS_27 -- When User clicks on update button, UpdateJobInformation function will get triggered */}
                                                            <button
                                                                type="button"
                                                                className="btn hive-btn-primary"
                                                                onClick={() => {
                                                                    UpdateJobInformation();
                                                                }}
                                                            >
                                                                Update
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="card border-0">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <label className="font-16 bold-text d-block">Job Posting Details</label>
                                                        </div>
                                                        <div className="col-md-12 mb-4">
                                                            <label className="form-label hive-form-label" htmlFor="department">
                                                                Department
                                                            </label>
                                                            <select
                                                                placeholder="Select"
                                                                onChange={onValueChange}
                                                                name="dropdown"
                                                                value={formData.departmentID}
                                                                id="departmentID"
                                                                className="form-select hive-form-select"
                                                            >
                                                                <option value={0}>Select</option>
                                                                {bindDepartment()}
                                                            </select>
                                                            <span style={{ color: 'red' }}>{departmentValidation}</span>
                                                        </div>
                                                        {Mode ? (
                                                            <div className="col-md-12 mb-4">
                                                                <label className="form-label hive-form-label" htmlFor="sourceID">
                                                                    Source
                                                                </label>
                                                                <span className="hive-form-mandatory"></span>
                                                                <select
                                                                    placeholder="Select"
                                                                    className="form-select hive-form-select"
                                                                    onChange={onValueChange}
                                                                    id="sourceID"
                                                                    name="dropdown"
                                                                    value={formData.sourceID}
                                                                    disabled //Add this line for disabling
                                                                    style={{
                                                                        backgroundColor: '#e9ecef',
                                                                        opacity: 1,
                                                                        cursor: 'not-allowed'
                                                                    }}
                                                                >
                                                                    <option value>Select</option>
                                                                    {bindSource()}
                                                                </select>
                                                            </div>
                                                        ) : (
                                                            <div className="col-md-12 mb-3">
                                                                <label
                                                                    className="form-label hive-form-label font-13 semibold-text jobdetails-label-color"
                                                                    htmlFor="department"
                                                                >
                                                                    Source
                                                                </label>
                                                                <label className="form-label hive-form-label w-100 font-14 semibold-text salary-label">
                                                                    {formData.source}
                                                                </label>
                                                            </div>
                                                        )}

                                                        {parseInt(formData.sourceID) === 1 && (


                                                            <div className="col-md-12 mb-4">
                                                                <label className="form-label hive-form-label" htmlFor="college">
                                                                    College
                                                                    <span className="hive-form-mandatory"></span>
                                                                </label>
                                                                <select

                                                                    className="form-select hive-form-select"
                                                                    onChange={onValueChange}
                                                                    id="collegeId"
                                                                    name="dropdown"
                                                                    value={formData.collegeId}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {bindCollege()}
                                                                </select>
                                                                <span style={{ color: 'red' }}>{collegeValidation}</span>
                                                            </div>
                                                        )}






                                                        <div className="col-md-12 mb-4">
                                                            <label className="form-label hive-form-label" htmlFor="experience">
                                                                Experience
                                                            </label>
                                                            <select
                                                                placeholder="Select"
                                                                id="experience"
                                                                name="dropdown"
                                                                onChange={onValueChange}
                                                                value={formData.experience}
                                                                className="form-select hive-form-select"
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="Fresher">Fresher</option>
                                                                <option value="Experienced">Experienced</option>
                                                            </select>
                                                            <span style={{ color: 'red' }}>{experienceValidation}</span>
                                                        </div>
                                                        <div className="col-md-12 mb-4">
                                                            <label className="form-label hive-form-label" htmlFor="location">
                                                                Location
                                                            </label>
                                                            <select
                                                                placeholder="Select"
                                                                id="location"
                                                                name="dropdown"
                                                                onChange={onValueChange}
                                                                value={formData.location}
                                                                className="form-select hive-form-select"
                                                                disabled={remoteDisable == true ? true : false}
                                                            >
                                                                <option value={''}>Select</option>
                                                                <option value={'India'}>India</option>
                                                                <option value={'USA'}>USA</option>
                                                            </select>
                                                            <span style={{ color: 'red' }}>{locationValidation}</span>
                                                        </div>
                                                        <div className="col-md-12 mb-4 align-items-center">
                                                            <input
                                                                className="form-check-input hive-form-check-input"
                                                                type="checkbox"
                                                                onChange={onValueChange}
                                                                checked={formData.remoteJob}
                                                                id="remoteJob"
                                                            />
                                                            <label htmlFor="RemoteJob" className="checkbox-label semibold-text  ms-2">
                                                                Mark as Remote Job
                                                            </label>
                                                            <span style={{ color: 'red' }}></span>
                                                        </div>
                                                        <div className="col-md-12 mb-4">
                                                            <label className="form-label hive-form-label" htmlFor="jobtype">
                                                                Job Type
                                                            </label>
                                                            <select
                                                                placeholder="Select"
                                                                id="employmentID"
                                                                name="dropdown"
                                                                onChange={onValueChange}
                                                                value={formData.employmentID}
                                                                className="form-select hive-form-select"
                                                            >
                                                                <option value={''}>Select</option>
                                                                {bindEmpType()}
                                                            </select>
                                                            <span style={{ color: 'red' }}>{employmentValidation}</span>
                                                        </div>
                                                        <div className="col-md-12 mb-4">
                                                            <label className="font-13 semibold-text jobdetails-label-color mt-4 d-block">
                                                                Salary Details
                                                            </label>
                                                            <label className="form-label hive-form-label" htmlFor="currency">
                                                                Currency <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <select
                                                                placeholder="Select"
                                                                name="dropdown"
                                                                onChange={onValueChange}
                                                                id="currencyID"
                                                                value={formData.currencyID}
                                                                className="form-select hive-form-select"
                                                            >
                                                                <option value={''}>Select</option>
                                                                {bindCurrency()}
                                                            </select>
                                                            <span style={{ color: 'red' }}>{currencyValidation}</span>
                                                        </div>
                                                        <div className="col-md-6 mb-4">
                                                            <label className="form-label hive-form-label" htmlFor="minsalary">
                                                                Min Salary <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                placeholder="Enter here"
                                                                name="decimal"
                                                                onChange={onValueChange}
                                                                value={formData.minSalary}
                                                                id="minSalary"
                                                                className="form-control hive-form-control"
                                                                min="0"
                                                            />
                                                            <span style={{ color: 'red' }}>{minSalaryValidation}</span>
                                                        </div>
                                                        <div className="col-md-6 mb-4">
                                                            <label className="form-label hive-form-label" htmlFor="maxsalary">
                                                                Max Salary <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                value={formData.maxSalary}
                                                                name="decimal"
                                                                onChange={onValueChange}
                                                                placeholder="Enter here"
                                                                id="maxSalary"
                                                                className="form-control hive-form-control"
                                                                min="0"
                                                            />
                                                            <span style={{ color: 'red' }}>{maxSalaryValidation}</span>
                                                        </div>
                                                        <h5 className="font-13 semibold-text jobdetails-label-color mt-4 border-top pt-4">
                                                            Created on
                                                        </h5>
                                                        <label className="font-13 semibold-text salary-label">
                                                            {moment(formData.createdAt).format('ll')}, at{' '}
                                                            {moment(formData.createdAt).format('LT')}
                                                            <span className="jobdetails-label-color font-13 semibold-text ms-1">
                                                                {' '}
                                                                (
                                                                {moment(formData.createdAt).format('L') == moment(new Date()).format('L')
                                                                    ? moment(formData.createdAt).startOf('minutes').fromNow()
                                                                    : moment(formData.createdAt).startOf('day').fromNow()}
                                                                )
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row mt-3">
                                        <div className="col-md-9">
                                            <div className="card border-0">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="d-flex justify-content-between">
                                                            <div className="col-md-5 mb-3">
                                                                <label className="form-label hive-form-label w-100 font-16 bold-text jobpost-label-color">
                                                                    Job Title
                                                                </label>
                                                                <label className="form-label hive-form-label w-100 font-14 semibold-text">
                                                                    {formData.jobTitle}
                                                                </label>
                                                            </div>
                                                            {/* PS_22 - PS_23 When user clicks on Edit button */}
                                                            <div>
                                                                <button
                                                                    hidden={
                                                                        recruitRole == 'Panel Member' && role !== 'Hr Manager'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    type="button"
                                                                    className="btn custom-edit-btn medium-text font-14"
                                                                    onClick={() => {
                                                                        setMode(true);
                                                                    }}
                                                                >
                                                                    <span>
                                                                        <img src="/Images/Edit.svg" className="me-2" />
                                                                    </span>
                                                                    Edit
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label className="font-16 bold-text form-label hive-form-label w-100 mb-2">
                                                                Job Description
                                                            </label>
                                                            {/* <label className="font-14 semibold-text form-label hive-form-label w-100 mb-2">Job Role :</label> */}
                                                            <p className="w-100 font-13 regular-text jobrole-description-color">
                                                                {parse(sanitizedDescription)}
                                                            </p>
                                                            {/* <label className="form-label hive-form-label w-100 jobpost-label-color">Responsibilities :</label>
                                                                           <ul className="font-13 regular-text jobrole-description-color">
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                           </ul>
                                                                           <label className="form-label hive-form-label w-100 jobpost-label-color">Requirements :</label>
                                                                           <ul className="font-13 regular-text jobrole-description-color">
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                                <li className="ms-4 mb-2">Lorem Ipsum is simply dummy text of the printing and typesetting
                                                                                     industry. Lorem Ipsum has been the industry's standard</li>
                                                                           </ul> */}
                                                        </div>
                                                        <div className="col-md-12">
                                                            <label className="form-label hive-form-label w-100 font-16 bold-text">
                                                                Skills
                                                            </label>
                                                            <label className="form-label hive-form-label w-100 jobrole-description-color font-13 regular-text">
                                                                {formData.skills}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="card border-0">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <label className="font-16 bold-text d-block">Job Posting Details</label>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label
                                                                className="form-label hive-form-label font-13 semibold-text jobdetails-label-color"
                                                                htmlFor="department"
                                                            >
                                                                Department
                                                            </label>
                                                            <label className="form-label hive-form-label w-100 font-14 semibold-text salary-label">
                                                                {formData.department}
                                                            </label>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label
                                                                className="form-label hive-form-label font-13 semibold-text jobdetails-label-color"
                                                                htmlFor="department"
                                                            >
                                                                Source
                                                            </label>
                                                            <label className="form-label hive-form-label w-100 font-14 semibold-text salary-label">
                                                                {formData.source}
                                                            </label>
                                                        </div>
                                                        {parseInt(formData.sourceID) === 1 && (
                                                            <div className="col-md-12 mb-3">
                                                                <label
                                                                    className="form-label hive-form-label font-13 semibold-text jobdetails-label-color"
                                                                    htmlFor="department"
                                                                >
                                                                    College
                                                                </label>
                                                                <label className="form-label hive-form-label w-100 font-14 semibold-text salary-label">
                                                                    {formData.college}
                                                                </label>
                                                            </div>
                                                        )}
                                                        <div className="col-md-12 mb-3">
                                                            <label
                                                                className="form-label hive-form-label font-13 semibold-text jobdetails-label-color"
                                                                htmlFor="experience"
                                                            >
                                                                Experience
                                                            </label>
                                                            <label className="form-label hive-form-label w-100 font-14 semibold-text salary-label">
                                                                {formData.experience}
                                                            </label>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
    <label
        className="form-label hive-form-label font-13 semibold-text jobdetails-label-color"
        htmlFor="location"
    >
        Location
    </label>
    <label className="form-label hive-form-label w-100 font-14 semibold-text salary-label">
        {formData.location ? formData.location : formData.remoteJob ? "Remote Location" : ""}
    </label>
</div>
                                                        <div className="col-md-12 mb-3">
                                                            <label
                                                                className="form-label hive-form-label font-13 semibold-text jobdetails-label-color"
                                                                htmlFor="location"
                                                            >
                                                                Job Type
                                                            </label>
                                                            <label className="form-label hive-form-label w-100 font-14 semibold-text salary-label">
                                                                {formData.employmentType}
                                                            </label>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label
                                                                className="form-label hive-form-label font-13 semibold-text jobdetails-label-color "
                                                                htmlFor="location"
                                                            >
                                                                Salary Details
                                                            </label>
                                                            <label className="form-label hive-form-label w-100 font-14 semibold-text salary-label">
                                                                {formData.currency}: {formData.minSalary} LPA - {formData.maxSalary} LPA
                                                            </label>
                                                        </div>
                                                        <h5 className="font-13 semibold-text jobdetails-label-color border-top pt-4 jobupdate-bottom-margin">
                                                            Created on
                                                        </h5>
                                                        <label className="font-13 semibold-text salary-label">
                                                            {moment(formData.createdAt).format('ll')}, at{' '}
                                                            {moment(formData.createdAt).format('LT')}{' '}
                                                            <span className="jobdetails-label-color font-13 semibold-text ms-1">
                                                                {' '}
                                                                (
                                                                {moment(formData.createdAt).format('L') == moment(new Date()).format('L')
                                                                    ? moment(formData.createdAt).startOf('minutes').fromNow()
                                                                    : moment(formData.createdAt).startOf('day').fromNow()}
                                                                )
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/*Content - Ends here */}
                            </div>
                            {/* Job Information Tab - ends here*/}

                            {/* Job Boards Tab */}

                            <div
                                className={job == null ? 'tab-pane fade ' : 'tab-pane fade show active'}
                                id="jobboards"
                                role="tabpanel"
                                aria-labelledby="jobboards-tab"
                            >
                                {/*Content - Starts here */}
                                <div className="row justify-content-center bg-white mt-3 ">
                                    <div className="col-md-12">
                                        <div className=" mx-0 bg-white mt-3">
                                            <div className="d-flex justify-content-between px-0 ">
                                                <div>
                                                    <label className="font-16 bold-text form-label px-0">Job Boards</label>
                                                    <p className="px-0 font-14 semibold-text salary-label">
                                                        Publish job to your favorite job boards to drive applicants to this job.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="table-responsive rounded-3 mt-4">
                                                        <table className="table bg-white hive-grid table-borderless ">
                                                            <thead className="hive-table-head ">
                                                                <tr>
                                                                    <th> </th>
                                                                    <th className="bold-text font-12">Job Board Name</th>
                                                                    <th className="bold-text font-12">Published Date</th>
                                                                    <th className="bold-text font-12 text-end">Candidates Applied</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="hive-table-data regular-text ">
                                                                    <td>
                                                                        {flag && (
                                                                            <div className="form-check ">
                                                                                <input
                                                                                    className="form-check-input table-body-label-style mt-1"
                                                                                    type="checkbox"
                                                                                    id="inlineCheckbox1"
                                                                                    defaultValue="option1"
                                                                                    onChange={(e) => submit(e)}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td className="bold-text font-13">Avasoft Career Site</td>
                                                                    <td className="bold-text font-13">{formData.published_at}</td>
                                                                    <td className="text-end bold-text font-13">{count}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                {flag && (
                                                    <div className="col-md-12 d-flex justify-content-end mb-4">
                                                        <button
                                                            className="btn hive-btn-secondary me-2"
                                                            onClick={() => {
                                                                cancelJob();
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className="btn hive-btn-primary"
                                                            onClick={() => {
                                                                save();
                                                            }}
                                                        >
                                                            Save
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*Content - Ends here */}
                            </div>
                            {/* Job Boards - Ends here */}

                            {/* Hiring Process Tab Starts Here */}
                            <HiringProcess job={formData.jobTitle} department={formData.department} />
                            {/* Hiring Process Tab Ends Here */}
                            {/* Candidates Tab Starts Here*/}
                            <div className="tab-pane fade" id="candidates" role="tabpanel" aria-labelledby="candidates-tab">
                                {/* <RecruiterComponent exp={experience} /> */}
                                {/* sent the experience value as props to new component RecruitmentComponent */}
                                <RecruitmentComponent exp={experience} />
                            </div>
                            {/* CandidatesTab - Ends here*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
